import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material'
import { tss } from 'tss-react/mui'
import { ButtonVariant } from './types'
import {
  getButtonBasePrimitives,
  getButtonDisabledPrimitives,
  getButtonVariantPrimitives,
} from './variants/primitives'

export interface ButtonProps extends Omit<MuiButtonProps, 'color' | 'variant' | 'classes'> {
  variant?: ButtonVariant
  floating?: boolean
  classes?: Partial<ReturnType<typeof useStyles>['classes']>
  dropdownAnimate?: boolean
}

/**
 * Renders a button with optional start and end icons
 */
export function Button({
  size = 'medium',
  variant = 'primary',
  floating = false,
  className,
  children,
  ...rest
}: ButtonProps) {
  const { classes, cx } = useStyles({
    classesOverrides: rest.classes,
    variant,
    floating,
  })
  return (
    <MuiButton
      className={cx(classes.button, className)}
      disableFocusRipple
      disableRipple
      disableTouchRipple
      size={size}
      {...rest}
    >
      {children}
    </MuiButton>
  )
}

const useStyles = tss
  .withParams<{
    variant: ButtonVariant
    floating: boolean
  }>()
  .create(({ variant, floating }) => ({
    button: {
      ...getButtonBasePrimitives(floating),
      ...getButtonVariantPrimitives(variant),
      ...getButtonDisabledPrimitives(variant),
    },
  }))
